// ops-subscription-modal.service.ts
import { Injectable } from '@angular/core';
import { SubscriptionStatus } from '@ops/shared-types';
import { BehaviorSubject, filter, Observable, Subject, take } from 'rxjs';

export interface ModalConfig {
  statusType: SubscriptionStatus;
  modalTitle?: string;
  modalText: string;
}

@Injectable({
  providedIn: 'root',
})
export class OpsSubscriptionModalService {
  private modalState = new Subject<{
    isOpen: boolean;
    config: ModalConfig | null;
  }>();
  private confirmationResult = new Subject<boolean>();

  getModalState(): Observable<{ isOpen: boolean; config: ModalConfig | null }> {
    return this.modalState.asObservable();
  }

  openModal(config: ModalConfig): Observable<boolean> {
    // Emit to show the modal
    this.modalState.next({
      isOpen: true,
      config,
    });

    // Return an observable that will emit only when confirmed/cancelled
    return this.confirmationResult.asObservable().pipe(take(1));
  }

  closeModal(): void {
    this.modalState.next({
      isOpen: false,
      config: null,
    });
  }

  confirm(confirmed: boolean): void {
    this.confirmationResult.next(confirmed);
    this.closeModal();
  }
}
